import { Accordion, Grid, Stack, styled } from '@mui/material';
import { SubwayAddAdGroup } from './Subway/SubwayAddAdGroup';

export const StyledSectionsWrapper = styled(Stack)(({ theme }) => ({
  marginTop: 0,
  flex: 1,
  overflowY: 'scroll',
  height: '100%',
  padding: theme.spacing(14, 6, 12, 0),
  transition: theme.transitions.create('margin-left', {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.standard,
  }),
  '&::-webkit-scrollbar': {
    display: 'none',
  },
}));

export const StyledSectionsOldWrapper = styled(Grid)({});

export const StyledSectionGeneral = styled(Accordion)(({ theme }) => ({
  padding: theme.spacing(5), //' 40 / 8 = 5,
  scrollMarginTop: theme.spacing(14), // consistent with vertical timeline
  backgroundColor: theme.palette.common.white,
  '&.MuiPaper-rounded': {
    borderRadius: 20,
  },
  '&:before': {
    display: 'none',
  },
  '&:not(:last-child)': {
    marginBottom: theme.spacing(3.125), // 25 / 8 = 3.125
  },
  '.MuiAccordionSummary-root.Mui-expanded': {
    minHeight: theme.spacing(3), // 24 / 8 = 3
  },
  '.MuiAccordionSummary-content.Mui-expanded': {
    marginTop: theme.spacing(1.5), // 12 / 8 = 1.5
  },
  '&.Mui-disabled': {
    backgroundColor: theme.palette.common.white,
  },
}));

export const StyledSectionOld = styled(StyledSectionGeneral)({
  '&.Mui-expanded': {
    margin: 'auto',
  },
});

export const StyledSection = styled(StyledSectionGeneral)(({ theme }) => ({
  marginLeft: theme.spacing(0.5),
  marginRight: theme.spacing(0.5),
  '&.Mui-expanded': {
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
  },
}));

export const StyledSubwayAddGroup = styled(SubwayAddAdGroup)(({ theme }) => ({
  padding: theme.spacing(3, 0, 3, 6),
  width: '100%',
}));
